import { get, post, patch, del } from './client.js';

export const getOne = (wsId) => get(`/workspaces/${wsId}`);
export const update = (wsId, body) => patch(`/workspaces/${wsId}`, body);
export const remove = (wsId) => del(`/workspaces/${wsId}`);

/* Members */
export const listMembers  = (wsId)               => get(`/workspaces/${wsId}/members`);
export const addMember    = (wsId, body)          => post(`/workspaces/${wsId}/members`, body);
export const updateMember = (wsId, wsMemberId, body) => patch(`/workspaces/${wsId}/members/${wsMemberId}/role`, body);
export const removeMember = (wsId, wsMemberId)   => del(`/workspaces/${wsId}/members/${wsMemberId}`);

/* Workspace-scoped resources */
export const getRuntime = (wsId)         => get(`/workspaces/${wsId}/runtime`);
export const getAudit   = (wsId, params) => get(`/workspaces/${wsId}/audit`, { params });
export const invite     = (wsId, body)   => post(`/workspaces/${wsId}/invite`, body);

/* H-01/H-02/H-05: module management — dep enforcement + per-module audit + events */
export const updateModules = (wsId, modules, reason) =>
  patch(`/workspaces/${wsId}/modules`, { modules, ...(reason ? { reason } : {}) });

/* H-04: reset to DEFAULT_WORKSPACE_MODULES */
export const resetModules = (wsId) => post(`/workspaces/${wsId}/modules/reset`, {});

/* M-06: archive workspace — sets status to ARCHIVED; delete requires ARCHIVED first */
export const archive = (wsId) => post(`/workspaces/${wsId}/archive`, {});

